export default __webpack_public_path__ + "static/media/interest.673d3a1e.svg";